{
  "link": {
    "invalidTitle": "Expired or invalid link",
    "invalidMessage": "Use the link you received by email or request a new link from the sender."
  },
  "login": {
    "title": "Sign in",
    "email": "Email",
    "emailPlaceholder": "Enter your email",
    "password": "Password",
    "passwordPlaceholder": "Enter your password",
    "submit": "Sign in",
    "twoFactorTitle": "Two-step verification",
    "twoFactorCode": "Verification code received by email",
    "verifyTwoFactor": "Verify code",
    "resendTwoFactorCode": "Resend code",
    "twoFactorSent": "A verification code has been sent by email",
    "selectCollaborator": "Select a collaborator",
    "submitCollaborator": "Sign in",
    "forgotPasswordText": "Forgot password?",
    "forgotPasswordButton": "Reset it",
    "success": "Signed in",
    "noCollaborator": "No collaborator is available for this account"
  },
  "forgotPassword": {
    "title": "Forgot password",
    "email": "Email",
    "emailPlaceholder": "Enter your email",
    "submit": "Send",
    "success": "A reset email has been sent"
  },
  "resetPassword": {
    "title": "Reset your password",
    "password": "Password",
    "confirmPassword": "Confirm password",
    "passwordPlaceholder": "Enter your password",
    "confirmPasswordPlaceholder": "Confirm your password",
    "submit": "Update",
    "success": "Password updated successfully"
  },
  "confirmation": {
    "title": "Set your password",
    "password": "New password",
    "confirmPassword": "Confirm your password",
    "passwordPlaceholder": "Enter your password",
    "confirmPasswordPlaceholder": "Confirm your password",
    "submit": "Update",
    "success": "Password created successfully"
  }
}
